export * from './filter.pipe';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/pipes/filter/index.ts